import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';

import { AbstractLayer, AbstractLayerProps, LayerProps } from './AbstractLayer';

/**
 * Implmentation of AbstractLayer for the OpenLayers OSM Layer Type
 */
export class OSMLayer extends AbstractLayer<TileLayer<OSM>> {
    private source: OSM | null;

    constructor({ config, opacity, visible, zIndex }: AbstractLayerProps) {
        super({ config, opacity, visible, zIndex });
        this.source = new OSM();
    }

    initializeLayer(props: LayerProps) {
        return new TileLayer({
            ...props,
            source: this.source || undefined,
        });
    }

    applyAuthentication() {}
}

export default OSMLayer;
